/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import { StatisticTypeEnum, processStatisticValue, getStatisticOption } from 'nmqf-common-ui';

interface DataRowRegionOverlayProps {
  name?: string;
  value?: string | number;
  zipCodeValue?: string | number;
  regionValue?: string | number;
  suffix?: string;
  prefix?: string;
  isNoFormat?: boolean;
}

export const extractRegionData = (statistic: StatisticTypeEnum | undefined, region: string, regionData?: any) => {
  let numerator, denominator, value, eventCount, stateValue;
  const targetRegionData = regionData?.[region];
  const stateCode = '17';
  const { percentage } = getStatisticOption(statistic) || {};

  numerator = processStatisticValue(
    targetRegionData?.populationStatisticData?.mapPatientCount[stateCode] ||
      targetRegionData?.rateOfAcuteEventsStatisticData?.mapTotalRateOfAcuteEventSelectedDemographic[stateCode] ||
      targetRegionData?.costOfAcuteEventsStatisticData?.mapCostOfAcuteEventSelectedDemographic[stateCode],
    false,
    statistic
  );
  denominator =
    statistic === StatisticTypeEnum.TotalCount
      ? 1
      : targetRegionData?.populationStatisticData?.mapPatientPopulationCount[stateCode] ||
        targetRegionData?.rateOfAcuteEventsStatisticData?.mapPatientCountSelectedDemographic[stateCode] ||
        targetRegionData?.costOfAcuteEventsStatisticData?.mapPatientCountSelectedDemographic[stateCode];
  value = processStatisticValue(numerator && denominator && numerator / denominator, percentage, statistic);
  eventCount = targetRegionData?.costOfAcuteEventsStatisticData?.mapCostOfAcuteEventHospitalizationVisit?.[stateCode];
  const patientPopulation = targetRegionData?.populationStatisticData?.mapPatientPopulationCount[stateCode];

  const stateNumerator = processStatisticValue(
    regionData?.statePatientCount || regionData?.stateTotalRateOfAcuteEventSelectedDemographic || regionData?.stateCostOfAcuteEventSelectedDemographic,
    false,
    statistic
  );
  const stateDenominator =
    statistic === StatisticTypeEnum.TotalCount ? 1 : regionData?.statePatientPopulationCount || regionData?.statePatientCountSelectedDemographic;
  stateValue = processStatisticValue(stateNumerator && stateDenominator && stateNumerator / stateDenominator, percentage, statistic);
  const statePatientPopulation = regionData?.statePatientPopulationCount;
  const stateEventCount = regionData?.stateCostOfAcuteEventHospitalizationVisit;

  return {
    numerator,
    denominator,
    value,
    eventCount,
    stateValue,
    stateNumerator,
    stateDenominator,
    patientPopulation,
    statePatientPopulation,
    stateEventCount,
  };
};
